module.exports = __webpack_public_path__ + "media/hph-25-07_student-experience.8eb43f57.mp4";